/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/organisation-product.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const OrganisationProductRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Product: oldRecord.Name,
        Name: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        Product: newRecord.Name,
        Name: null,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { OrganisationProductRecordChangeGrid };
